import { gql } from 'apollo-boost';

export const BB_TOKEN_QUERY = gql`
    query bunchballToken {
        bunchballToken {
            accessToken
        }
    }
`;
